class ProductWhatsAppContact extends HTMLElement {
  connectedCallback() {
    this.link = this.querySelector('[data-whatsapp-contact-link]');
    if (!this.link) return;

    this.sectionId = String(this.dataset.sectionId || '');
    this.baseUrl = this.dataset.baseUrl || '';
    this.message = (this.dataset.message || '').trim();
    this.includeProductDetails = this.dataset.includeProductDetails === 'true';
    this.productTitle = this.dataset.productTitle || '';
    this.productUrl = this.dataset.productUrl || window.location.href;
    this.variantTitle = this.dataset.variantTitle || '';
    this.variantId = this.dataset.variantId || '';

    this.updateLink();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribeVariantChange = subscribe(
        PUB_SUB_EVENTS.variantChange,
        this.handleVariantChange.bind(this),
      );
    }
  }

  disconnectedCallback() {
    this.unsubscribeVariantChange?.();
  }

  handleVariantChange({ data } = {}) {
    if (!data || String(data.sectionId) !== this.sectionId) return;

    this.variantTitle = data.variant?.title || '';
    this.variantId = data.variant?.id ? String(data.variant.id) : '';
    this.updateLink();
  }

  updateLink() {
    if (!this.baseUrl || !this.link) return;

    try {
      const contactUrl = new URL(this.baseUrl, window.location.origin);
      const messageParts = [];

      if (this.message) messageParts.push(this.message);

      if (this.includeProductDetails) {
        if (this.productTitle) messageParts.push(`Product: ${this.productTitle}`);
        if (this.variantTitle && this.variantTitle !== 'Default Title') {
          messageParts.push(`Variant: ${this.variantTitle}`);
        }

        const productUrl = new URL(this.productUrl, window.location.origin);
        if (this.variantId) productUrl.searchParams.set('variant', this.variantId);
        messageParts.push(`Link: ${productUrl.toString()}`);
      }

      if (messageParts.length > 0) contactUrl.searchParams.set('text', messageParts.join('\n\n'));
      this.link.href = contactUrl.toString();
    } catch (_error) {
      this.link.href = this.baseUrl;
    }
  }
}

if (!customElements.get('product-whatsapp-contact')) {
  customElements.define('product-whatsapp-contact', ProductWhatsAppContact);
}
